import React from "react";

const iconProps = {
  width: 15,
  height: 15,
  viewBox: "0 0 20 20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  "aria-hidden": true,
};

export const BulletListIcon = () => (
  <svg {...iconProps}>
    <path d="M7 5h9M7 10h9M7 15h9" />
    <circle cx="3.5" cy="5" r="1" fill="currentColor" stroke="none" />
    <circle cx="3.5" cy="10" r="1" fill="currentColor" stroke="none" />
    <circle cx="3.5" cy="15" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const NumberedListIcon = () => (
  <svg {...iconProps}>
    <path d="M7 5h9M7 10h9M7 15h9M2 4l1.4-.6V6.6M2 9.2h2.4L2 12.4h2.4M2 13.8h2.2l-1.4 1.2h.3a1 1 0 1 1 0 2H2" />
  </svg>
);

export const LinkIcon = () => (
  <svg {...iconProps} width={14} height={14}>
    <path d="M8.5 11.5l3-3M7 13l-1 1a2.8 2.8 0 0 1-4-4l1-1M13 7l1-1a2.8 2.8 0 0 0-4-4l-1 1" />
  </svg>
);
